import { OptionCountProps } from './OptionCount.types';
import { useStyles } from './OptionCount.styles';
import { Typography } from '../../../../../../../Typography';

export const OptionCount = ({ isActive, count }: OptionCountProps) => {
  const styles = useStyles({ isActive, count });
  return (
    <div css={styles.root}>
      <Typography css={styles.typography}>{count}</Typography>
    </div>
  );
};
